module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div>\n	<style>\n		.array-control-list {\n			border-spacing: 1px;\n			border-collapse: separate;\n		}\n\n		.array-control-list > div > div {\n			padding: 2px 5px;\n			background: #f8f8f8;\n		}\n	</style>\n	<div name=\"list-items\" class=\"table w100 array-control-list\"></div>\n</div>")
  }
  return __output.join("");

}